<template>
  <div class="mutation-main">
    <div @scroll="scrollChange" class="mutation-list" ref="scrollView">
      <div class="title">
        <!-- <span style="width: 50%">核苷酸</span> -->
        <span style="width: 70%">氨基酸</span>
        <span style="width: 30%">阳性样本数</span>
      </div>
      <div class="show-box"></div>
      <div class="list" v-for="(item, index) in snvList" :key="index">
        <!-- <span style="width: 50%">{{ item.cdnaChange }}</span> -->
        <span @click="handleClick1(item)" style="width: 70%; color: #4b84ff">{{
          item.proteinChange
        }}</span>
        <span @click="handleClick(item)" style="color: #4b84ff; width: 30%">{{
          item.cohort
        }}</span>
      </div>
    </div>
    <!-- <div class="page">
      <p :class="{ active: isActive }"></p>
      <p :class="{ active: isTwo }"></p>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    snvList: {
      type: Array,
    },
  },
  data() {
    return {
      isActive: true,
      isTwo: false,
    };
  },
  mounted() {},
  methods: {
    handleClick1(item) {
      console.log(item);
      let param = {
        name: "wdJiedu",
        type: "1",
        gene: item.variation,
        proteinChange: item.proteinChange,
        tabIndex: "2",
        fromSource: "snv",
      };
      this.$emit("anClick", param);

    },
    handleClick(item) {
      let param = {
        name: "wdJiedu",
        type: "0",
        gene: "",
        proteinChange: item.proteinChange,
        tabIndex: "1",
        fromSource: "snv",
      };
      this.$emit("geneSnvClick", param);
    },
    scrollChange(e) {
      const scrollLeft = e.target.scrollLeft;
      const scrollW = e.target.scrollWidth;
      const W = this.$refs.scrollView.clientWidth;
      if (scrollW - W === scrollLeft) {
        this.isActive = false;
        this.isTwo = true;
      } else {
        this.isActive = true;
        this.isTwo = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  width: 121%;
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}
.mutation-main {
  font-family: @family;
  background: @background_color;
  border-radius: 10px;
  padding-bottom: 30px;
  margin-bottom: 22px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 100%;
    background: #f4f8fd;
    opacity: 0.3;
  }
  .page {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    padding-right: 24px;
    .active {
      background: #2f354d;
    }
    p {
      width: 6px;
      height: 6px;
      background: #d4d6dd;
      border-radius: 6px;
      margin-left: 12px;
    }
  }
  .mutation-list {
    overflow-x: scroll;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-y: hidden;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .title {
      height: 48px;
      padding: 0 24px;
      box-sizing: border-box;
      width: 100%;
      font-size: 15PX;
      font-weight: 500;
      color: #9095a7;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .list {
      width: 100%;
      height: 48px;
      padding: 0 24px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 15PX;
      font-weight: 400;
      color: #2f354d;
      line-height: 22px;

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
